<template>
    <b-container>
      <b-row v-if="success" class="text-center pt-4">
        <b-col>
          <b-alert show variant="success">
            <p>{{ $t("info.successgeneric") }}</p>
          </b-alert>
        </b-col>
      </b-row>
      <b-form v-else @submit="onSubmit">
        <b-alert show variant="danger">
          <p>{{ $t("action.removeAnnualBudgetData") }}</p>
        </b-alert>
  
        <b-button
          class="mt-4 text-center"
          type="submit"
          variant="danger"
          :disabled="disabled"
          >{{ $t("action.submit") }}</b-button
        >
  
        <div v-if="error" class="pt-4">
          <b-alert show variant="info">
            <p>{{ error }}</p>
          </b-alert>
        </div>
  
        <div v-if="spinner" class="text-center align-middle">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="success"
            label="Spinning"
            disabled="labelStatus"
          ></b-spinner>
        </div>
      </b-form>
    </b-container>
  </template>
  
  <script>
  import axios from "axios";
  import { globalF } from "../../Helpers";
  
  export default {
    mixins: [globalF],
    props: ["year"],
    data() {
      return {
        form: {},
        spinner: false,
        disabled: false,
        error: "",
        success: false,
      };
    },
    computed: {
      url: function () {
        return this.getUrl();
      },
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();
        this.error = "";
        this.spinner = true;
        this.form.request = "removeBudget";
        this.form.YEAR = this.year;
  
        axios
          .post(this.url, this.form, {
            headers: { "Content-Type": "application/json" },
          })
          .then(() => {
            this.disabled = false;
            this.spinner = false;
            this.success = true;
          })
          .catch(() => {
            this.error = this.$t("info.errorgeneric");
            this.disabled = false;
            this.spinner = false;
          });
      },
    },
  };
  </script>
  